<template>
  <div class="mt-3 flex justify-center">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
    <img
      v-if="brokerLogo"
      class="mx-auto h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h3 class="mb-8 text-left text-3xl text-dark-gray">Log in</h3>
    <p class="paragraph my-5 text-left">
      Enter the email address associated with your Highway account.
    </p>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <form-field
        ref="formField"
        :auto-focus="true"
        label="Email Address"
        :value="email_address"
        placeholder="Enter Email Address"
        :on-input="onEmailInput"
        :on-blur="checkEmailAddress"
        :error="email_address_error"
        name="email_address"
      />
      <button-main
        class="my-3 mb-4"
        :disabled="!!email_address_error"
        type="submit"
        :loading-spinner="isLoading"
        value="Continue"
      />
    </form>

    <div class="mt-4 flex flex-col items-center">
      <p class="mb-2 text-body-color">Don't have an account?</p>
      <router-link
        to="/sign-up/carrier-details"
        class="mx-auto w-max text-sm text-yellow-500"
      >
        Sign Up
      </router-link>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import placeholderFormData from '@/common/placeholderFormData';
import { toastResponse } from '@/common/handleServerResponse';

// Mixin
import fullnameAndEmailField from '@/mixins/fullnameAndEmailField';

export default {
  name: 'LoginWithEmail',
  components: {
    Layout,
    ButtonMain,
    FormField,
  },
  mixins: [fullnameAndEmailField],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
  },
  mounted() {
    this.data = placeholderFormData;
  },
  async created() {
    await this.$store.dispatch(
      'brokers/getLogoByClientId',
      localStorage.getItem('client_id')
    );
  },
  methods: {
    onEmailInput(e) {
      this.handleFieldUpdate(e);
    },
    async handleSubmit() {
      this.isLoading = true;
      const res = await this.$store.dispatch('users/postSignIn', {
        email_address: this.email_address,
        site: 'highway.com',
      });
      if ([200, 201].includes(res?.status)) {
        // email address login success
        // send user login verification step
        this.$router.push({
          name: 'LoginVerification',
          query: { fromEmail: true },
        });
      } else {
        // Phone number does not exist -- prompt to create an account
        toastResponse(this, res, null);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
small,
p {
  @apply text-sm !important;
}
</style>
